import * as CANNON from 'cannon-es';

export class PhysicsWorld {
  public readonly world: CANNON.World;

  constructor() {
    // Create physics world
    this.world = new CANNON.World();
    this.world.gravity.set(0, -12, 0); // Moderate gravity for good air time

    // Use SAPBroadphase for better performance with many objects
    this.world.broadphase = new CANNON.SAPBroadphase(this.world);

    // Default contact material
    const defaultMaterial = new CANNON.Material('default');
    const groundMaterial = new CANNON.Material('ground');

    const defaultContact = new CANNON.ContactMaterial(
      defaultMaterial,
      groundMaterial,
      {
        friction: 0.5,
        restitution: 0.1,
      }
    );
    this.world.addContactMaterial(defaultContact);

    // Create ground
    this.createGround(groundMaterial);
  }

  private createGround(material: CANNON.Material): CANNON.Body {
    const groundBody = new CANNON.Body({
      type: CANNON.Body.STATIC,
      shape: new CANNON.Plane(),
      material: material,
    });
    groundBody.quaternion.setFromEuler(-Math.PI / 2, 0, 0);

    // Ground collision group 1, only collide with non-player objects
    // Player bike handles ground contact manually for smoother ramp physics
    groundBody.collisionFilterGroup = 1;
    groundBody.collisionFilterMask = 4; // Only collide with group 4 (projectiles, etc)

    this.world.addBody(groundBody);
    return groundBody;
  }

  public step(dt: number): void {
    this.world.step(dt);
  }

  public addBody(body: CANNON.Body): void {
    this.world.addBody(body);
  }

  public removeBody(body: CANNON.Body): void {
    this.world.removeBody(body);
  }

  public getWorld(): CANNON.World {
    return this.world;
  }
}
